import React from "react";

function AboutComponent() {
  return (
    <div className="about-portfolio text-center">
      <h2>Before You Continiue With Our Portfolio ...</h2>
      <p className="text-left">
        Let us help you to understand our portfolio. This not a complete list of
        our products but we've enough B2C software to showcase. We also develop
        B2B software. Though it's not available publicly but We've shared some
        of the software name which you can check at Internal Business Software
        section.
      </p>
    </div>
  );
}

export default AboutComponent;
